import lodashOmit from 'lodash/omit';
/** enhance lodash type */
export var omit = function (classes, keys) {
    return lodashOmit(classes, keys);
};
